import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        {/* Header với nút Back */}
        <div style={styles.header}>
          <Link to="/" style={styles.backBtn}>{"⟵"}</Link>
        </div>

        <h1 style={styles.h1}>Privacy Policy</h1>
        <p style={styles.date}><strong>Last updated:</strong> Jan 2026</p>

        <p style={styles.p}>
          NimBosk respects your privacy. This policy explains how we handle
          information when you use the app.
        </p>

        <h2 style={styles.h2}>Information We Collect</h2>
        <p style={styles.p}>
          NimBosk does not require account registration. The app may collect
          basic technical data automatically, such as device type, operating
          system version, and crash reports to improve performance and stability.
        </p>

        <h2 style={styles.h2}>How We Use Information</h2>
        <p style={styles.p}>
          Collected information is used only to maintain app functionality,
          improve user experience, and fix technical issues.
        </p>

        <h2 style={styles.h2}>Third-Party Services</h2>
        <p style={styles.p}>
          The app may use third-party services such as analytics or advertising
          providers. These services may collect information according to their
          own privacy policies.
        </p>

        <h2 style={styles.h2}>Data Storage</h2>
        <p style={styles.p}>
          Drawings and animations created in NimBosk are stored locally on your
          device unless you choose to share or export them.
        </p>

        <h2 style={styles.h2}>Children's Privacy</h2>
        <p style={styles.p}>
          NimBosk does not knowingly collect personal information from children.
        </p>

        <h2 style={styles.h2}>Changes to This Policy</h2>
        <p style={styles.p}>
          We may update this Privacy Policy from time to time. Continued use of
          the app after changes means you accept the updated policy.
        </p>

        <h2 style={styles.h2}>Contact</h2>
        <p style={styles.p}>Email: nimbosk@gmail.com</p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
    minHeight: "100vh",
    background: "#fff",
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale"
  },

  container: {
    padding: "16px",
    maxWidth: "100%",
    boxSizing: "border-box"
  },

  header: {
    marginBottom: 20,
    paddingTop: 8
  },

  backBtn: {
    display: "inline-flex",
    alignItems: "center",
    fontSize: "clamp(20px, 6vw, 26px)", 
    color: "#000000",
    textDecoration: "none",
    padding: "8px 0",
    WebkitTapHighlightColor: "transparent",
    fontWeight:"900"
  },

  h1: {
    fontSize: "clamp(28px, 7vw, 36px)",
    margin: "0 0 8px 0",
    fontWeight: "bold",
    lineHeight: 1.2
  },

  date: {
    fontSize: "clamp(14px, 3.5vw, 16px)",
    color: "#666",
    margin: "0 0 24px 0"
  },

  h2: {
    fontSize: "clamp(20px, 5vw, 24px)",
    margin: "32px 0 12px 0",
    fontWeight: "600",
    lineHeight: 1.3
  },

  p: {
    fontSize: "clamp(16px, 4vw, 18px)",
    lineHeight: 1.7,
    margin: "0 0 16px 0",
    color: "#333"
  }
};